/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

interface CioConditionEditorDeviceAttributeArgs {
  condition: DeviceAttributeCondition;
  actionItems: { value: string; label: string }[];
  customerItems: { value: string; label: string }[];
  changeType: () => unknown;
  onRemove: () => unknown;
  onDuplicate?: () => unknown;
  canDuplicate?: boolean;
  disabled?: boolean;
}

export default class CioConditionEditorDeviceAttribute extends Component<CioConditionEditorDeviceAttributeArgs> {
  @service auth!: AuthService;

  get canDuplicate() {
    return this.args.canDuplicate ?? false;
  }

  get disabled() {
    return this.args.disabled ?? false;
  }
}
